import React, { useState, useEffect } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { toast } from "react-toastify";
import moment from "jalali-moment";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import useFetch from "../../../../context/useFetch";
import AdminOrderCard from "../../shares/AdminOrderCard";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";
import { fixNumbers, translateColor, translateGender } from "../../../../utils";
import SizeTextGrid from "../../../shares/SizeTextGrid";
import { useSetting } from "../../../../context/SettingContext";
// import { defaultRingSize } from "../../../../constants/constants";

const OrderDetails = (props) => {
  let windowWidth = window.screen.width;
  const { defaultRingSize } = useSetting();
  const [openModal, setOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [patchData, setPatchData] = useState();
  const [childrenItemDate, setChildrenItemDate] = useState();
  const [selecteItemStatus, setSelectItemStatus] = useState();
  const [currentOerdersDetail, setCurrentOerdersDetail] = useState(undefined);
  const [initialValues, setInitialValues] = useState({});
  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const update_nums = (ringId, ind, nValue) => {
    let beforeNums = { ...initialValues };

    beforeNums[ringId][ind] = nValue;
    setInitialValues(beforeNums);
  };

  const getCreateOrderDetailsApi = useFetch({
    method: "get",
    url: `BangleStock_Service/${props.selectedRow?.id}`,
    trigger: false,
    setter: setCurrentOerdersDetail,
    // params: { admin_change_item: false },
    argFunc: (res) => {
      let tmp = {};
      // res.results.map((item, ind) => {
      tmp[res.id] = [];
      tmp[res.id].push(res.size_one_num);
      tmp[res.id].push(res.size_two_num);
      tmp[res.id].push(res.size_three_num);
      tmp[res.id].push(res.size_four_num);
      tmp[res.id].push(res.size_five_num);
      tmp[res.id].push(res.size_six_num);
      // });

      setInitialValues(tmp);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const updateDetailsApi = useFetch({
    method: "patch",
    url: `BangleStock_Service/${selectedItem}`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      // toast.success("ویرایش موجودی  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setOpenModal(false);
      getCreateOrderDetailsApi.reFetch();
      props.getRequestListApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const deleteDetailsApi = useFetch({
    method: "patch",
    url: `BangleStock_Service/${selectedItem}`,
    trigger: false,
    data: { is_active: !selecteItemStatus },
    argFunc: (res) => {
      // toast.success("ویرایش مورد نظر  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getCreateOrderDetailsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);
    setPatchData({
      size_one_num:
        initialValues[ringItemId][0] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][0]))
          : 0,
      size_two_num:
        initialValues[ringItemId][1] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][1]))
          : 0,
      size_three_num:
        initialValues[ringItemId][2] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][2]))
          : 0,
      size_four_num:
        initialValues[ringItemId][3] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][3]))
          : 0,
      size_five_num:
        initialValues[ringItemId][4] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][4]))
          : 0,
      size_six_num:
        initialValues[ringItemId][5] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][5]))
          : 0,
      receive_at: moment(childrenItemDate).format("YYYY-MM-DD"),
    });
    updateDetailsApi.reFetch();
  };

  const delete_ring_item = (ringItemId, is_acitve) => {
    setSelectedItem(ringItemId);
    setSelectItemStatus(is_acitve);
    deleteDetailsApi.reFetch();
  };

  const move_date_to_parent = (date) => {
    setChildrenItemDate(date);
  };

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          setInitialValues({});
          getCreateOrderDetailsApi.reFetch();
        }
  }, [openModal]);

  let random_num = Math.random() * 10;

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<RemoveRedEyeIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        {currentOerdersDetail && (
          <div>
            <div className="flex justify-between items-center mt-4 mb-4 border-dashed border-b pb-2">
              <div>
                <span className="show-label">
                  کد :{" "}
                  <span className="show-value"> {props.selectedRow?.code}</span>
                </span>
              </div>
            </div>
            <SizeTextGrid haveExtraCol have5Col />
            <div className="overflow-scroll max-h-96">
              {currentOerdersDetail !== undefined && (
                <AdminOrderCard
                  update_ring_item={update_ring_item}
                  delete_ring_item={delete_ring_item}
                  item={currentOerdersDetail}
                  move_date_to_parent={move_date_to_parent}
                  DontShowDatePicker
                  DontshowEditIconForAdmin
                  showAcceptBtn
                >
                  <OrderCardLeftPartTemplate
                    nums={nums}
                    update_nums={update_nums}
                    dynamicMap={true}
                    data_item={currentOerdersDetail}
                    ringId={currentOerdersDetail.id}
                    cantEdit
                    DontShowAcceptItem
                    customerCanEdit
                    random_num={random_num}
                  />
                </AdminOrderCard>
              )}
            </div>
          </div>
        )}
      </TableIconModal>
    </>
  );
};

export default OrderDetails;
